document.addEventListener("DOMContentLoaded", function () {
  var url = window.location.href;

  if (url.includes("google-my-business")) {
    // console.log("URL contains 'google-my-business'");
    let shadowRootFound = false;
    const checkForShadowRoot = () => {
      if (shadowRootFound) {
        return; // Exit the function if shadow root is already found
      }

      const shadowHosts = document.querySelectorAll(".mwa-widget-container");

      shadowHosts.forEach((shadowHost) => {
        if (shadowHost && shadowHost.shadowRoot) {
          const targetNode = shadowHost.shadowRoot;
          // console.log('Shadow root found:', targetNode);
          observeAndAppendStyles(targetNode); // Start observing and append styles
          shadowRootFound = true; // Set the flag to true
        } else {
          // console.error('Shadow root not found for:', shadowHost);
          setTimeout(checkForShadowRoot, 1000);
        }
      });
    };

    const observeAndAppendStyles = (targetNode) => {
      let stylesAppended = false;
      console.log("stylesAppended", "stylesAppended", targetNode);
      const appendStyles = () => {
        if (!stylesAppended) {
          // CSS styles to be appended
          var style = document.createElement("style");
          style.classList.add("custom-style");
          style.textContent = `
          .mwa-accessbility-sidebar {
            bottom: 30px;
            right: 30px;
            border: none;
            background-color: transparent;
          }
  
          .mwa-accessbility-sidebar .draggable-image-div img {
            border-radius: 15px;
          }
  
          .mwa-popup-img-col img {
            height: auto !important;
            border-radius: 20px;
          }
  
          .mwa-inline-vertical {
            background-color: var(--kit-ink);
            border-radius: 20px !important;
          }
  
          .draggable-image-div {
            margin-top: 20px;
            background: transparent;
          }
  
          .draggable-image-div img {
            width: 100% !important;
            height: auto !important;
            display: block;
          }
      
          .mwa-vertical-para {
            color: var(--kit-surface);
            font-size: 14px;
            line-height: 1.5;
            margin: .75em 0;
            font-family: var(--font-body-family);
            font-weight: 300;
          }
          
          .mwa-accessibility-sidebar-cross {
            background-color: var(--kit-ink) !important;
            right: -10px;
            top: -10px;
            left: inherit;
            z-index: 9999999999999999;
          }
  
          .mwa-gdpr-div {
            color: var(--kit-surface) !important;
            font-size: 14px;
            font-family: var(--font-body-family);
            font-weight: 300;
          }
  
          .mwa-gdpr-description {
            line-height: 1.5;
            font-size: 14px;
            margin-bottom: 10px !important;
          }
          
          .mwa-gdpr-description, .mwa-gdpr-div label {
            color: var(--kit-surface) !important;
          }
  
          .mwa-gdpr-checkbox-div input {
            top: 2px;
          }
  
          .mwa-form input {
            border: none;
            background-color: var(--kit-surface);
            color: var(--kit-ink);
            padding: 12px 45px 12px 12px;
            border-radius: 10px;
          }
  
          .mwa-tooltip-popup-wrapper {
            border-color: var(--kit-grey-300);
            top: 0px;
            height: 45px;
            right: 1px;
            line-height: 2.5;
            border-radius: 0 10px 10px 0;
            border-width: 1px;
          }
  
          .mwa-tooltip-popup {
            background: var(--kit-accent);
            color: var(--kit-accent-contrast);
          }
  
          .mwa-tooltip-popup::after {
            border-color: var(--kit-accent) transparent transparent;
          }
  
          .mwa-gdpr-description {
            line-height: 1.5;
          }
  
          .mwa-key-08d664 .mwa-popup-container {
            margin: 0 auto;
            top: 50%;
            transform: translate(-50%, -50%);
            max-width: 700px;
          }
          
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col {
            padding: 20px;
            background-color: var(--kit-surface);
            color: var(--kit-ink);
            border-radius: 20px;
          }
  
          .mwa-sidebar-form button[type="submit"] {
            border-radius: 10px;
            font-family: var(--font-heading-family);
            letter-spacing: 2px;
          }
  
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col,
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-heading,
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-para {
            color: var(--kit-ink);
            font-family: var(--font-body-family);
          }
  
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-heading {
            margin-bottom: 10px;
          }
  
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-para {
            margin: 0 0 20px !important;
          }
  
         .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-form input {
            border: 1px solid var(--kit-ink);
            border-radius: 10px;
          }
  
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-tooltip-popup-wrapper {
            border-color: var(--kit-ink);
            top: 1px;
            height: 45px;
            right: 1px;
            line-height: 2.5;
            border-radius: 0 10px 10px 0;
            border-width: 1px;
          }
  
          .mwa-key-08d664 .mwa-popup-container .mwa-popup-col button[type="submit"] {
            border-radius: 10px;
            font-family: var(--font-heading-family);
            letter-spacing: 2px;
          }
  
          /* Modify opacity */
          .mwa-widget-container div {
            opacity: 1 !important;
          }
  
          @media screen and (max-width: 767px) {
            .mwa-accessbility-sidebar {
              padding-top: 0;
            }
  
            .mwa-accessbility-sidebar {
              bottom: 15px;
              right: 15px;
            }
  
            .mwa-accessibility-sidebar-cross {
              right: -10px;
              top: -10px;
            }
  
            .mwa-key-08d664 .mwa-popup-container {
              max-width: 500px;
              padding: 0 20px;
            }
  
            .mwa-key-08d664 .mwa-popup-text-col {
              width: 100%;
              padding: 0;
              text-align: center;
            }
  
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col {
              padding: 30px;
            }
  
            .mwa-gdpr-checkbox-div {
              padding-left: 30px !important;
            }
          
          }

        `;
          targetNode.appendChild(style);
          stylesAppended = true; // Set the flag to true
          if (stylesAppended == true) {
            setTimeout(function () {
              document.body.classList.remove("loader_show");
            }, 1500);
          }
        }
      };

      const observerConfig = {
        childList: true,
        subtree: true,
      };

      const observerCallback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            const popupContainers = targetNode.querySelectorAll(
              ".mwa-widget-container"
            );
            console.log(popupContainers, "popupContainers");
            popupContainers.forEach((container) => {
              appendStyles(); // Append styles for each container
              console.log(container, "container");
            });
            observer.disconnect(); // Disconnect the observer after appending styles
          }
        }
      };

      const observer = new MutationObserver(observerCallback);
      observer.observe(targetNode, observerConfig);

      const checkTargetNode = () => {
        const popupContainers = targetNode.querySelectorAll(
          ".mwa-widget-container"
        );
        console.log(popupContainers, "popupContainers");
        if (popupContainers.length > 0) {
          popupContainers.forEach((container) => {
            console.log(container, "container");

            appendStyles(); // Append styles for each container
          });
          observer.disconnect(); // Disconnect the observer after appending styles
        } else {
          requestAnimationFrame(checkTargetNode); // Re-check
        }
      };

      checkTargetNode(); // Start the periodic check
    };

    checkForShadowRoot();
  } else {
    // console.log("URL does not contain 'google-my-business'");

    function addStylesToShadowRoot() {
      if(document.querySelector(".mwa-widget-container")){
        var element = document.querySelector(".mwa-widget-container");
        var shadow = element.shadowRoot;
        if (shadow) {
          var style = document.createElement("style");
          style.textContent = `
            .mwa-accessbility-sidebar {
              bottom: 30px;
              right: 30px;
              border: none;
              background-color: transparent;
            }
    
            .mwa-accessbility-sidebar .draggable-image-div img {
              border-radius: 15px;
            }
    
            .mwa-popup-img-col img {
              height: auto !important;
              border-radius: 20px;
            }
    
            .mwa-inline-vertical {
              background-color: var(--kit-ink);
              border-radius: 20px !important;
            }
    
            .draggable-image-div {
              margin-top: 20px;
              background: transparent;
            }
    
            .draggable-image-div img {
              width: 100% !important;
              height: auto !important;
              display: block;
            }
        
            .mwa-vertical-para {
              color: var(--kit-surface);
              font-size: 14px;
              line-height: 1.5;
              margin: .75em 0;
              font-family: var(--font-body-family);
              font-weight: 300;
            }
            
            .mwa-accessibility-sidebar-cross {
              background-color: var(--kit-ink) !important;
              right: -10px;
              top: -10px;
              left: inherit;
              z-index: 9999999999999999;
            }
    
            .mwa-gdpr-div {
              color: var(--kit-surface) !important;
              font-size: 14px;
              font-family: var(--font-body-family);
              font-weight: 300;
            }
    
            .mwa-gdpr-description {
              line-height: 1.5;
              font-size: 14px;
              margin-bottom: 10px !important;
            }
            
            .mwa-gdpr-description, .mwa-gdpr-div label {
              color: var(--kit-surface) !important;
            }
    
            .mwa-gdpr-checkbox-div input {
              top: 2px;
            }
    
            .mwa-form input {
              border: none;
              background-color: var(--kit-surface);
              color: var(--kit-ink);
              padding: 12px 45px 12px 12px;
              border-radius: 10px;
            }
    
            .mwa-tooltip-popup-wrapper {
              border-color: var(--kit-grey-300);
              top: 0px;
              height: 45px;
              right: 1px;
              line-height: 2.5;
              border-radius: 0 10px 10px 0;
              border-width: 1px;
            }
    
            .mwa-tooltip-popup {
              background: var(--kit-accent);
              color: var(--kit-accent-contrast);
            }
    
            .mwa-tooltip-popup::after {
              border-color: var(--kit-accent) transparent transparent;
            }
    
            .mwa-gdpr-description {
              line-height: 1.5;
            }
    
            .mwa-key-08d664 .mwa-popup-container {
              margin: 0 auto;
              top: 50%;
              transform: translate(-50%, -50%);
              max-width: 700px;
            }
            
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col {
              padding: 20px;
              background-color: var(--kit-surface);
              color: var(--kit-ink);
              border-radius: 20px;
            }
    
            .mwa-sidebar-form button[type="submit"] {
              border-radius: 10px;
              font-family: var(--font-heading-family);
              letter-spacing: 2px;
            }
    
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col,
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-heading,
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-para {
              color: var(--kit-ink);
              font-family: var(--font-body-family);
            }
    
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-heading {
              margin-bottom: 10px;
            }
    
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-popup-text-col .mwa-popup-para {
              margin: 0 0 20px !important;
            }
    
           .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-form input {
              border: 1px solid var(--kit-ink);
              border-radius: 10px;
            }
    
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col .mwa-tooltip-popup-wrapper {
              border-color: var(--kit-ink);
              top: 1px;
              height: 45px;
              right: 1px;
              line-height: 2.5;
              border-radius: 0 10px 10px 0;
              border-width: 1px;
            }
    
            .mwa-key-08d664 .mwa-popup-container .mwa-popup-col button[type="submit"] {
              border-radius: 10px;
              font-family: var(--font-heading-family);
              letter-spacing: 2px;
            }
    
            /* Modify opacity */
            .mwa-widget-container div {
              opacity: 1 !important;
            }
    
            @media screen and (max-width: 767px) {
              .mwa-accessbility-sidebar {
                padding-top: 0;
              }
    
              .mwa-accessbility-sidebar {
                bottom: 15px;
                right: 15px;
              }
    
              .mwa-accessibility-sidebar-cross {
                right: -10px;
                top: -10px;
              }
    
              .mwa-key-08d664 .mwa-popup-container {
                max-width: 500px;
                padding: 0 20px;
              }
    
              .mwa-key-08d664 .mwa-popup-text-col {
                width: 100%;
                padding: 0;
                text-align: center;
              }
    
              .mwa-key-08d664 .mwa-popup-container .mwa-popup-col {
                padding: 30px;
              }
    
              .mwa-gdpr-checkbox-div {
                padding-left: 30px !important;
              }
            
            }
    
          `;
  
          shadow.appendChild(style);
        }
      }
    }
    setTimeout(addStylesToShadowRoot, 2000);
    window.addEventListener("scroll", function () {
      var scrollPosition = window.scrollY + window.innerHeight;
      var documentHeight = document.body.scrollHeight;
      if (scrollPosition >= documentHeight) {
        var element = document.querySelector("#mwa-key-dea50e");
        element.classList.add("mwa-active");
      }
    });
  }
});
